import { api } from 'app/config/apiConfig';

import { Box, BoxDeactivationReason } from '../model/types';

interface DeactivateBoxParams {
  boxId: string;
  deactivationReason: BoxDeactivationReason;
  deactivatedUntil?: string;
}

export const deactivateBoxApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deactivateBox: builder.mutation<Box, DeactivateBoxParams>({
      query: ({ boxId, deactivationReason, deactivatedUntil }) => ({
        url: `/boxes/${boxId}/deactivate`,
        method: 'PUT',
        body: {
          deactivationReason,
          deactivatedUntil,
        },
      }),
      invalidatesTags: ['Boxes', 'Available boxes', 'Warehouses for booking'],
    }),
  }),
});

export const { useDeactivateBoxMutation } = deactivateBoxApi;
